"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateNewShareClassMethodRequest = exports.CreateNewShareClassSchema = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
const constants_1 = require("../constants");
/**
 * Schema for create new share class method validation
 * {@link ICreateNewShareClass}
 */
const CreateNewShareClassSchema = yup.object().shape({
    name: yup
        .string()
        .trim()
        .transform((value) => (!value ? undefined : value))
        .required("Please enter share class name")
        .max(60)
        .min(1),
    code: yup
        .string()
        .trim()
        .transform((value) => (!value ? undefined : value))
        .required("Please enter share class code")
        .matches(constants_1.ALPHANUMERIC_REGEX, "Share class code can only contain letters and numbers")
        .max(4)
        .min(1),
});
exports.CreateNewShareClassSchema = CreateNewShareClassSchema;
/**
 * Validates create new share class method request schema
 * @param data: create new share class method request {@link ICreateNewShareClass} to validate
 */
const validateCreateNewShareClassMethodRequest = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield CreateNewShareClassSchema.validate(data, {
            abortEarly: false,
        });
        return;
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
});
exports.validateCreateNewShareClassMethodRequest = validateCreateNewShareClassMethodRequest;
//# sourceMappingURL=CreateNewShareClass.js.map